export const getUnsplashAppId = () => (process.env.NODE_ENV === 'production' ? 175002 : 270477);
